<template>
    <div class="parmodel">
        <el-dialog :title="title" :visible="dialogStationVisible" :before-close="beforeClose" width="80%" center v-loading="loading"
   >
            <div >
                <div class="mantit"><p class="p1"></p><p class="p2"></p><span class="titinfo">{{$t('manipulation.choice')}}</span></div>
                <div class="air">
                    <div class="air_con">
                        <p>
                            <span v-for="(item,index) in deviceinfo" :key='index'><span v-if="item.lh">{{$t('manipulation.buildNum')}}：{{item.lh}},</span> <span v-if="item.th">{{$t('manipulation.ladderNum')}}：{{item.th}};</span></span>
                        </p>
                    </div>
                </div>
                <div v-if="title===`${$t('manipulation.manModeParSetting')}`">
                     <div class="mantit"><p class="p1"></p><p class="p2"></p><span class="titinfo">{{$t('manipulation.paSelect')}}</span></div>
                        <div class="para">
                            <div class="para_con">
                                <div class="para_list">
                                    <div class="para_left">
                                        <div class="oper_left"><div class="oper_but oper_but1"> <i class="el-icon-menu"></i> {{$t('manipulation.model')}}</div> </div>
                                    </div>
                                    <div class="para_right">
                                        <div v-for="(item,index) in patternList" :key='index' @click="changepat(item)">
                                            <p><img :src="pattern===item.val?item.url:item.url1"  style="width:32px"/></p>
                                            <p :class="pattern===item.val?'ischck':''">{{item.name}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="para_list">
                                    <div class="para_left">
                                        <div class="oper_left"><div class="oper_but oper_but1"> <i class="el-icon-stopwatch"></i> {{$t('manipulation.temp')}}</div> </div>
                                    </div>
                                    <div class="para_right">
                                        <el-input v-model="temperatures" @input="tempblur"  :disabled='isdisabled' type='number' max='31' min='16'></el-input>
                                        <span style="margin-left:5px"> °C</span>
                                        <span style="margin-left:35px">( {{$t('manipulation.temRange')}} 16°C - 31°C )</span>
                                    </div>
                                </div>
                                <div class="para_list">
                                    <div class="para_left">
                                        <div class="oper_left"><div class="oper_but oper_but1"> <i class="el-icon-rank"></i> {{$t('manipulation.windSpeed')}}</div> </div>
                                    </div>
                                    <div class="para_right">
                                        <div v-for="(item,index) in speedlist" :key='index' @click="changespe(item)">
                                            <p><img :src="wind===item.val?item.url:item.url1" style="width:32px"/></p>
                                            <p :class="wind===item.val?'ischck':''">{{item.name}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mantit"><p class="p1"></p><p class="p2"></p><span class="titinfo">{{$t('manipulation.devStatus')}}</span></div>
                        <div class="oper">
                            <div class="oper_con">
                                <div class="oper_left"><div class="oper_but " :class="workStatus=='0' || workStatus=='' ? 'oper_but1':''" @click="setwork('0')"> <i class="el-icon-user"></i> {{$t('realtimeinfo.turnOff')}}</div> </div>
                                <div><el-switch v-model="workStatus" active-value="1" inactive-value="0" active-color="#67C23A" disabled inactive-color="#67C23A"></el-switch></div>
                                <div class="oper_left"><div class="oper_but " :class="workStatus=='1'? 'oper_but1':''" @click="setwork('1')"><i class="el-icon-date"></i>{{$t('realtimeinfo.powerOn')}}</div></div>
                            </div>
                        </div>
                </div>
                <div v-if="title===`${$t('manipulation.timModeParSetting')}` || title==`${$t('realdetile.timeModeView')}`">
                    <div class="mantit"><p class="p1"></p><p class="p2"></p><span class="titinfo">{{$t('manipulation.benTimeSetting')}}</span></div>
                        <div class="settime">
                            <div class="settime_con">
                                <div class="settime_tit">{{$t('manipulation.curHour')}}</div>
                                <div class="settime_val">
                                    <el-time-picker v-model="time" :placeholder="$t('manipulation.anyTime')" format='HH:mm'></el-time-picker>
                                </div>
                            </div>
                            <div class="settime_con">
                                <div class="settime_tit">{{$t('manipulation.currentWeek')}}</div>
                                <div class="settime_val">
                                    <el-select v-model="week" class="pick" :placeholder="$t('dataAnalysis.pleCho')">
                                        <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        
                        <div class="mantit"><p class="p1"></p><p class="p2"></p><span class="titinfo">{{$t('manipulation.timeSet')}}</span>
                        <div class="add"><el-button type="primary" icon="el-icon-circle-plus" :v-if="title!=`${$t('realdetile.timeModeView')}`" @click="addtime">{{$t('manipulation.addTime')}}</el-button></div>
                        </div>
                        <div class="timing">
                            <div class="timing_con">
                                <div class="timing_list" v-for="(item,index) in timinglist" :key='index' :class="item.activetime?'activelist':''">
                                    <div class="tim1">{{item.name}}</div>
                                    <div class="tim">{{$t('manipulation.timedOn')}}：<el-time-picker class="pick" size='mini' v-model="item.timeOn" format='HH:mm'></el-time-picker></div>
                                    <div class="tim">{{$t('manipulation.timedOff')}}：<el-time-picker class="pick" size='mini' v-model="item.timeOff" format='HH:mm'></el-time-picker></div>
                                    
                                    <div class="tim">{{$t('manipulation.model')}}：<el-select @change="e=>chagesel(e,item,index)" v-model="item.pattern" class="pick" :placeholder="$t('dataAnalysis.pleCho')">
                                        <el-option
                                        v-for="item in patoptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select></div>
                                     <div class="tim">{{$t('manipulation.temp')}}：<el-input :disabled="fun(`disabled${index}`)" v-model="item.temperatures" type="number" max='31' min='16' class="pick" placeholder=""></el-input></div>
                                    <div class="tim">{{$t('manipulation.windSpeed')}}：<el-select v-model="item.wind" class="pick" :placeholder="$t('dataAnalysis.pleCho')">
                                        <el-option
                                        v-for="item in optionswind"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select></div>
                                   
                                    <div class="tim tim2">{{$t('manipulation.week')}}：
                                        <el-select v-model="item.week" class="pick" multiple collapse-tags :placeholder="$t('dataAnalysis.pleCho')">
                                            <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                    </el-select></div>
                                    <div class="tim1" v-if="title!=$t('realdetile.timeModeView')"><i class="el-icon-remove-outline" @click="closetime(item)"></i></div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                 
            <div slot="footer" class="dialog-footer">
                <el-button size='small' class="button--cancel" @click="handleClose">{{$t('manipulation.cancel')}}</el-button>
                <el-button size='small' type="primary" @click="handleSubmit"  :loading="loading1">{{$t('manipulation.sure')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPage, setGateway } from '@/api/admin/userStation';
import { projectPage,projectList } from '@/api/deviceOverview/file';
import { multiplewrite,multiplecurrent,getDeviceTimerStreamIdByDeviceId} from "@/api/devicemon";
import moment from 'moment'
import _ from "lodash"
// import { filter } from 'vue/types/umd';
export default {
    name: 'parmodel',
    props: {
        dialogStationVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
           
        }
    },
    data() {
        return {
            loading1:false,
            loading:false,
          workStatus:'0',
          workval:"",
           temperatures:'24',
           time:'',
           week:'',
            options: [{
                value: '1',
                label: this.$t('parmodel.theMonday')
                }, {
                value: '2',
                label: this.$t('parmodel.theTuesday'), 
                },{
                value: '3',
                label: this.$t('parmodel.theWednesday')
                },{
                value: '4',
                label: this.$t('parmodel.theThursday')
                },{
                value: '5',
                label: this.$t('parmodel.theFriday')
                },{
                value: '6',
                label: this.$t('parmodel.theSaturday')
                },{
                value: '7',
                label: this.$t('parmodel.theSunday')
                }
            ],
            patoptions:[
                { value: 'automate',  label: this.$t('manipulation.auto')},
                { value: 'blowing',  label: this.$t('manipulation.wind')},
                { value: 'cold',  label: this.$t('realdetile.refrigeration')},
                { value: 'hot',  label: this.$t('realdetile.heating')},
            ],
            disabled0:false,
            disabled1:false,
            disabled2:false,
            disabled3:false,
            disabled4:false,
            disabled5:false,
            disabled6:false,
            disabled7:false,
            disabled8:false,
            disabled9:false,
            optionswind:[
                {
                value: 'high',
                label: this.$t('realdetile.highWind')
                },{
                value: 'low',
                label: this.$t('realdetile.lowWind')
                }
            ],
       
            timinglist:[
                {name:this.$t('manipulation.timer')+'01',timeOn:'',timeOff:'',week:[],pattern:'',wind:'',temperatures:'',streamId:18},
               
            ],
            timing:[
                {name:this.$t('manipulation.timer')+'01',streamId:18},{name:this.$t('manipulation.timer')+'02',streamId:20},{name:this.$t('manipulation.timer')+'03',streamId:28},
                {name:this.$t('manipulation.timer')+'04',streamId:30},{name:this.$t('manipulation.timer')+'05',streamId:38},{name:this.$t('manipulation.timer')+'06',streamId:40},
                {name:this.$t('manipulation.timer')+'07',streamId:48},{name:this.$t('manipulation.timer')+'08',streamId:50},{name:this.$t('manipulation.timer')+'09',streamId:58},
                {name:this.$t('manipulation.timer')+'10',streamId:60},
            ],
            patternList:[
                {name:this.$t('manipulation.auto'),url:require('@/assets/img/time/zdl.png'),url1:require('@/assets/img/time/zda.png'),val:'automate'},
                {name:this.$t('realdetile.heating'),url:require('@/assets/img/time/jrl.png'),url1:require('@/assets/img/time/jra.png'),val:'hot'},
               
                {name:this.$t('realdetile.refrigeration'),url:require('@/assets/img/time/zll.png'),url1:require('@/assets/img/time/zla.png'),val:'cold'},
                {name:this.$t('manipulation.wind'),url:require('@/assets/img/time/sfl.png'),url1:require('@/assets/img/time/sfa.png'),val:'blowing'},
                
            ],
            pattern:'automate',
            isdisabled:true,
            speedlist:[
                {name:this.$t('realdetile.lowWind'),url:require('@/assets/img/time/dfl.png'),url1:require('@/assets/img/time/dfa.png'),val:'low'},
                {name:this.$t('realdetile.highWind'),url:require('@/assets/img/time/gfl.png'),url1:require('@/assets/img/time/gfa.png'),val:'high'},
            ],
            wind:'high',
            wayinfo:"",
            deviceinfo:[],
            arrdevlist:[],
            streamIdList:'',
            arr:[
            '18','19','1a','1b','1c','1d','1e','1f',
            '20','21','22','23','24','25','26','27',
            '28','29','2a','2b','2c','2d','2e','2f',
            '30','31','32','33','34','35','36','37',
            '38','39','3a','3b','3c','3d','3e','3f',
            '40','41','42','43','44','45','46','47',
            '48','49','4a','4b','4c','4d','4e','4f',
            '50','51','52','53','54','55','56','57',
            '58','59','5a','5b','5c','5d','5e','5f',
            '60','61','62','63','64','65','66','67',
            ],
            arr1:'18,19,1a,1b,1c,1d,1e,1f,20,21,22,23,24,25,26,27,28,29,2a,2b,2c,2d,2e,2f,30,31,32,33,34,35,36,37,38,39,3a,3b,3c,3d,3e,3f,40,41,42,43,44,45,46,47,48,49,4a,4b,4c,4d,4e,4f,50,51,52,53,54,55,56,57,58,59,5a,5b,5c,5d,5e,5f,60,61,62,63,64,65,66,67,',
        };
    },
    created() {
        // this.param.userId = sessionStorage.getItem('stationUserId');
        // this.init();
    },
    mounted() {},
    watch:{
       
    },
    methods: {
       
        chagesel(val,info,index){
          
            if(val=="automate" || val =="blowing"){
                this[`disabled${index}`] = true
            }else{
                this[`disabled${index}`] = false
            }
        },
         fun(text){
            return eval(this[`${text}`]); //这样写字符串就可以当做变量使用，否则会返回字符串
        },
        setwork(val){
            this.workStatus = val
        },
        test(){
             console.log(this.temperatures)
        },
        tempblur: _.debounce(function() {
                if(this.temperatures<16 || this.temperatures>31){
               
                    this.$message.error(this.$t('parmodel.temMoreRange'))
                    return
                }else{
                    this.$message.closeAll()
                }
            }, 800),
        getDeviceTimerStreamIdByDeviceId:async function(){
           await getDeviceTimerStreamIdByDeviceId({deviceId:this.wayinfo[0].id}).then(res=>{
                if(res.data.code==200){
                    
                    this.streamIdList = res.data.data
                }
            })
        },
        getallinfo:async function(info){
           
            this.wayinfo = JSON.parse(JSON.stringify(info))
            let arr = []  // 获取选中空调信息
            let arr1 = []  // 判断数组中哪些属于空调
           await this.getDeviceTimerStreamIdByDeviceId()
            this.wayinfo.map((item,index)=>{
                if(item.towerNumber || item.stairsNumber){
                    arr.push({lh:item.towerNumber,th:item.stairsNumber})
                }
                if(item.onenetId&&item.devCode){
                    arr1.push(item)
                }
            })
            // 获取批量选择时 devcode
            this.arrdevlist = arr1

            this.deviceinfo = arr
            // 批量选择时 选择时多个不再获取数据
            if(arr1.length!=1){
                return
            }
            if(this.title==this.$t('manipulation.manModeParSetting')){
                let obj = {
                    onenetId:arr1[0].onenetId,
                    devCode:arr1[0].devCode,
                    streamIds:'13,12,11'
                }
                this.loading = true
                multiplecurrent(obj).then(res=>{
                    if(res.data.code===200){
                        res.data.data.map((item,index)=>{
                            let time = ''
                            let time1 = ''
                            if(item.streamId==='12'){
                                this.temperatures = (!item.monitorValue||item.monitorValue==255)?'24':item.monitorValue
                            }else if(item.streamId==='11'){
                                this.workval = item.monitorValue
                                let a = item.monitorValue.split('')
                                this.workStatus = a[0]
                            }else if(item.streamId==='13'){

                                let a = item.monitorValue.split('')
                                if(a[2]=='1'){
                                    this.wind = 'high'
                                }
                                if(a[3]=='1'){
                                    this.wind = 'low'
                                }
                                let b = ["00","01","10","11"]
                                let c = item.monitorValue.substr(item.monitorValue.length-2,2)
                                b.map((v,i)=>{
                                    if(v===c){
                                        this.pattern = this.patternList[i].val
                                        if(this.pattern =='hot' || this.pattern=='cold'){
                                            this.isdisabled = false
                                        }
                                    }
                                })
                            }

                        })
                    }
                    this.loading = false
                })
            }else if(this.title==this.$t('manipulation.timModeParSetting') || this.title==this.$t('realdetile.timeModeView')){
                // 获取定时模式实时数据
                let str = this.streamIdList.concat(",15",",16",",17")
                let obj = {
                    onenetId:arr1[0].onenetId,
                    devCode:arr1[0].devCode,
                     streamIds:str
               }
                this.loading = true
                multiplecurrent(obj).then(res1=>{
                     this.loading = false
                    if(res1.data.code===200){
                        let result = []  
                        let time = ''
                        let time1 = ''
                        let resdata = []
                        res1.data.data.map((item,index)=>{
                            if(item.streamId==='15'){
                                time = item.monitorValue
                            }else if(item.streamId==='16'){
                                time1 = item.monitorValue
                            }else if(item.streamId==='17'){
                                this.week = item.monitorValue
                            }else{
                                if(item.streamId.indexOf("G")==-1){
                                    resdata.push(item)
                                }
                            }

                        })
                        let nowdate = new Date(`2020-01-01 ${time}:${time1}:00`).valueOf()
                        let testlist= [1,2,3,4,5,6,7,8,9,10]
                        testlist.map((t,c)=>{
                            let res = []
                            resdata.map((item,index)=>{
                                if(index<8*t & index>=8*(t-1)){
                                    res.push(item)
                                }
                            })
                            console.log(res)
                          
                            if(res.length>0&&res[0].monitorValue){
                                let a = this.timing.filter(v=>v.streamId==res[0].streamId)
                                let activetime = false
                                let pat = res[4].monitorValue
                                let wind = res[6].monitorValue==='1'?'low':'high'
                                let weeklist = []
                                res[7].monitorValue.split("").map((v,i)=>{
                                    if(i<7&&v=='1'){
                                        weeklist.push((7-i).toString())
                                    }
                                })
                                let sttime = new Date(`2020-01-01 ${res[0].monitorValue}:${res[1].monitorValue}:00`).valueOf()
                                let endtime = new Date(`2020-01-01 ${res[2].monitorValue}:${res[3].monitorValue}:00`).valueOf()
                                if(nowdate>=sttime && nowdate<=endtime){
                                    activetime = true
                                }
                                let obj = {
                                    name:a[0].name,timeOn:`2020-01-01 ${res[0].monitorValue}:${res[1].monitorValue}`,timeOff:`2020-01-01 ${res[2].monitorValue}:${res[3].monitorValue}`,
                                    pattern:this.patternList[`${pat}`].val,wind:wind,temperatures:res[5].monitorValue!='255'?res[5].monitorValue:"",week:weeklist,streamId:a[0].streamId,activetime:activetime
                                }
                                if(obj.pattern=="automate" || obj.pattern =="blowing"){
                                    this[`disabled${c}`] = true
                                }else{
                                    this[`disabled${c}`] = false
                                }
                                result.push(obj)
                            }
                        })
                        this.time = `2020-01-01 ${time}:${time1}`
                      
                        this.timinglist = result
                    }
                    this.loading = false
                })
            }
            // 获取实时信息
        },
        init() {
            this.timinglist =[{name:this.$t('manipulation.timer')+'01',timeOn:'',timeOff:'',week:[],pattern:'',wind:'',temperatures:'',streamId:18}]
            this.disabled0 = false
             this.disabled1 = false
              this.disabled2 = false
             this.disabled3 = false
             this.disabled4 = false
             this.disabled5 = false
             this.disabled6 = false
             this.disabled7 = false
             this.disabled8 = false
             this.disabled9 = false
            this.wind ='high'
            this.wayinfo= ""
            this.deviceinfo =[]
            this.workStatus ='0'
            this.temperatures ='24'
            this.time =''
            this.pattern ='automate'
            this.week =''
        },
        changepat(info){
            this.pattern = info.val
            if(info.val=='cold'||info.val=='hot'){
                this.isdisabled = false
                this.temperatures = info.val=='cold'?24:18
            }else{
                this.isdisabled = true
                 this.temperatures = 24
            }
        },
        changespe(num){
            this.wind = num.val
        },
        // 提交表单
        handleSubmit() {
            if(this.title===this.$t('realdetile.timeModeView')){
                this.$emit('closepar');
                return
            }
            let obj=[]
            let falg = true
            if(this.title===this.$t('manipulation.timModeParSetting')){
                  // 批量处理
                if(this.arrdevlist.length>1){
                    this.arrdevlist.map((item,i)=>{
                        obj.push({
                            streamId:'15,16,17',
                            type:3,
                            onenetId:this.wayinfo[i].onenetId,
                            deviceId:this.wayinfo[i].id,
                            devCode:item.devCode,
                            monitorValue:{time:moment(this.time).format('HH:mm'),week:this.week}
                        })
                    })
                }else{
                    obj.push({
                        streamId:'15,16,17',
                        type:3,
                        onenetId:this.wayinfo[0].onenetId,
                        deviceId:this.wayinfo[0].id,
                        devCode:this.wayinfo[0].devCode,
                        monitorValue:{time:moment(this.time).format('HH:mm'),week:this.week}
                    })
                }
                let arrlist = JSON.parse(JSON.stringify(this.timinglist))
                arrlist.sort(this.compare( "streamId"));
                arrlist.map(item=>{
                    if(item.week.length<1 || !item.timeOn || !item.timeOff|| !item.pattern || !item.wind || (!item.temperatures&&(item.pattern==='hot'|| item.pattern==='cold')) ){
                        this.$message.error(this.$t('parmodel.necTimer'))
                        return falg =false
                    }
                    if((item.temperatures<16 || item.temperatures >31)&&(item.pattern==='hot'|| item.pattern==='cold')){
                        this.$message.error(this.$t('parmodel.necTimer')+'16°C - 31°C')
                        return falg =false
                    }
                    if(Array.isArray(item.week)){
                        item.week = item.week.sort()
                        item.week = item.week.toString()
                    }
                    if(item.timeOn){
                        item.timeOn = moment(item.timeOn).format('HH:mm')
                    }
                    if(item.timeOff){
                        item.timeOff = moment(item.timeOff).format('HH:mm')
                    }
                    // 批量处理
                    if(this.arrdevlist.length>1){
                        this.arrdevlist.map((v)=>{
                            obj.push({
                                type:3,
                                onenetId:v.onenetId,
                                devCode:v.devCode,
                                deviceId:v.id,
                                streamId:item.streamId,
                                monitorValue:item
                            })
                        })
                        
                    }else{
                        obj.push({
                            type:3,
                            onenetId:this.wayinfo[0].onenetId,
                            devCode:this.wayinfo[0].devCode,
                            deviceId:this.wayinfo[0].id,
                            streamId:item.streamId,
                            monitorValue:item
                        })
                    }
                    
                })
                if(falg){
                    this.$emit('parsocket','time');
                }
            }else if(this.title == this.$t('manipulation.manModeParSetting')){
                if(!this.temperatures){
                    this.$message.error(this.$t('parmodel.noTemEmpty'))
                    return
                }
                if(this.temperatures<16 || this.temperatures>31){
                    this.$message.error(this.$t('parmodel.pleTemRight'))
                    return
                }
                if(this.arrdevlist.length>1){
                   
                    this.arrdevlist.map((v)=>{
                       
                        obj.push({
                            streamId:'13,12',
                            type:2,
                            onenetId:v.onenetId,
                            deviceId:v.id,
                            devCode:v.devCode,
                            monitorValue: {
                                pattern: this.pattern,
                                temperatures: this.temperatures,
                                wind: this.wind,
                            }
                        },{
                            streamId:'11',
                            type:2,
                            onenetId:v.onenetId,
                            devCode:v.devCode,
                            deviceId:v.id,
                            monitorValue: {
                                workStatus: this.workStatus,monitorValue:this.workval
                            }
                        }) 
                    })
                       
                }else{
                    obj.push({
                        streamId:'13,12',
                        type:2,
                        onenetId:this.wayinfo[0].onenetId,
                        deviceId:this.wayinfo[0].id,
                        devCode:this.wayinfo[0].devCode,
                        monitorValue: {
                            pattern: this.pattern,
                            temperatures: this.temperatures,
                            wind: this.wind,
                        }
                    },{
                        streamId:'11',
                        type:2,
                        onenetId:this.wayinfo[0].onenetId,
                        devCode:this.wayinfo[0].devCode,
                        deviceId:this.wayinfo[0].id,
                        monitorValue: {
                            workStatus: this.workStatus,monitorValue:this.workval
                        }
                    }) 
                }
             
                this.$emit('parsocket','hanld');
            }
            if(falg){
                this.loading1 = true
                multiplewrite(obj).then(res=>{
                    if(res.data.code==200){
                        this.$message.success(this.$t('parmodel.pointIssued'))
                        this.$emit('closepar','1');
                        this.init()
                    }
                    this.loading1 = false
                })
            }
            
        },
        compare( propertyName) {
            return  function( object1,  object2) {
                var value1  = object1[propertyName];
                var value2  = object2[propertyName];
                if (value2  < value1) {
                    return  1;
                }  else  if (value2  > value1) {
                    return  - 1;
                }  else {
                    return  0;
                }
            }
        },
        beforeClose(done) {
            this.init()
            this.$emit('closepar');
            done();
        },
        handleClose(num) {
            this.init()
            this.$emit('closepar',num);
        },
        addtime(){
            let tim = JSON.parse(JSON.stringify(this.timinglist))
            let tim1 = JSON.parse(JSON.stringify(this.timing))
         
            tim.map((item)=>{
              let b = this.timing.filter(v=>v.streamId==item.streamId)
              if(b.length>0){
                  tim1.map((v,i)=>{
                      if(v.streamId===b[0].streamId){
                          tim1.splice(i,1)
                      }
                  })
              }
            })
            if(tim1.length>0){
                this.timinglist.push({name:tim1[0].name,timeOn:'',timeOff:'',week:[],pattern:'',wind:'',temperatures:'',id:1,streamId:tim1[0].streamId})
            }else{
                this.$message.error(this.$t('parmodel.mostAddTenPiece'))
            }
            
        },
       
        closetime(val){
            if(this.timinglist.length<2){
                this.$message.error(this.$t('parmodel.leastOnePiece'))
                return
            }
            this.timinglist.map((item,index)=>{
                if(item.streamId===val.streamId){
                    this.timinglist.splice(index,1)
                }
            })
        }
      
    }
};
</script>

<style lang="scss" scoped>
.parmodel {
    .mantit{
           display: flex;
           align-items: center;
           margin-bottom: 10px;
           .p1{
               width:3px;
               height: 16px;      
               background: #01AAA7;
               margin-right: 2px;
           }
           .p2{
               width:5px;
               height: 16px;      
               background: #01AAA7;
                margin-right: 5px;
           }
           .titinfo{
               color: #333;
               font-size: 14px;
               font-weight: 600;
               letter-spacing: 3px;
           }
           .add{
               flex:1;
               text-align: end;
           }
       }
    .air{
        padding: 2%;
        background: #F2FBFB;
        .air_con{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
        }
    }
    .para{
        padding: 2%;
        background: #F2FBFB;
        .para_con{
            .para_list{
                display: flex;
                margin-bottom: 25px;
                .para_left{
                    width:30%;
                    display: flex;
                    align-items: center;
                }
                .para_right{
                    width: 70%;
                    display: flex;
                    align-items:center;
                    div{
                        width: 25%;
                        p{
                            margin: 0;
                        }
                    }
                    .ischck{
                        color: #01AAA7;
                    }
                }
            }
        }
    }
    .oper_left{ 
       width:100%;
       display: flex;
       justify-content: center;
       .oper_but{
           width: 150px;
           height: 45px;
           color: #01AAA7;
           letter-spacing: 3px;
           text-align: center;
           line-height: 45px;
           border-radius:5px;
           background:#D9F3F2;
       }
    }
            
     .settime{
         width:100%;
         display: flex;
         margin-bottom: 20px;
         .settime_con{
             display: flex;
             float: left;
             width: 45%;
             margin-right: 5%;
             .settime_tit{
                // padding: 10px 20px;
                background: #F2FBFB;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
             }
         }
    }
    .timing{
        .timing_con{
            
            .timing_list{
                 display: flex;
                 border-left: 1px solid #ececec;
                 border-top: 1px solid #ececec;
                .tim{
                    flex:2;
                    border-right: 1px solid #ececec;
                    border-bottom: 1px solid #ececec;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 5px 0;
                }
                .tim2{
                    flex:3
                }
                .tim1{
                    border-right: 1px solid #ececec;
                    display: flex;
                    border-bottom: 1px solid #ececec;
                    justify-content: center;
                    align-items: center;
                    padding: 0  10px;
                    .el-icon-remove-outline{
                        font-size: 28px;
                        color: #ED5E5E;
                    }
                }
                .pick{
                    width: 60%;
                }
            }
            .activelist{
                background: #70dde2;
            }
        }
    }
    .oper{
           background: #F2FBFB;
           padding: 3%;
           width: 42%;
           .oper_con{
               display: flex;
               align-items: center;
               justify-content: center;
           }
       }
        .oper_left{
            width:250px;
            display: flex;
            justify-content: center;
            .oper_but{
                width: 150px;
                height: 40px;
                color: #fff;
                letter-spacing: 3px;
                text-align: center;
                line-height: 40px;
                border-radius:5px;
                background: #ccc;
            }
            .oper_but1{
                background: #67C23A;
            }
          
            .oper_but2{
                background:#DAA342;
            }
        }        
}
</style>
